export const FRANCE = 'FRANCE';
export const PAYS_BAS = 'PAYS-BAS';



// WEBPACK FOOTER //
// ./src/constants/countries.js